<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Course editor
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="min-height: 300px; padding-top: 20px;">
      <div class="internal-spinner" *ngIf="state === 'loading'">
        <svg class="spinner" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
        </svg>
      </div>
      <div *ngIf="state === 'error'">
        Error. <br>{{errMsg}}
      </div>

      <div *ngIf="['error','loading'].indexOf(state) === -1">

        <mat-form-field appearance="outline" color="accent"
                        style="width: 100%; margin-top: 24px">
          <mat-label>Course title</mat-label>
          <mat-icon matPrefix>title</mat-icon>
          <input matInput [formControl]="titleValue" type="text">
        </mat-form-field>
        <div fxLayout="row" fxLayoutAlign="start center" class="field-error-message"
             *ngIf="validationResult && !validationResult.isValid && validationResult.messagesPerControls['titleValue']">
          <mat-icon color="warn">error</mat-icon><span>{{validationResult.messagesPerControls['titleValue']}}</span>
        </div>

        <app-quick-uploader [picture_src]="picture_src_preview" [aspect_ratio]="aspect_ratio"
                            (new_picture_src_ava)="picture_src_ava = $event"
                            (new_picture_src_icon)="picture_src_icon = $event"
                            (new_picture_src_preview)="picture_src_preview = $event"
                            (new_aspect_ratio)="aspect_ratio = $event"
        >
        </app-quick-uploader>
      </div>

    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        Cancel
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        Save
      </button>
    </div>
  </div>
</form>
